(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name home.matches.controller:MatchesCtrl
   *
   * @description
   *
   */
  angular
    .module('neo.home.comite')
    .controller('comiteCtrl', comiteCtrl);

  function comiteCtrl(AclService,Comite, townHalls, currentSeason, $mdToast, $filter, $scope, $state) {
    var vm = this;
    vm.currentSeason = angular.copy(currentSeason);
     vm.sancionsshow=false;
    if( AclService.isAdmin()){
        townHalls.unshift({id:9999, name:'Tots', email:'', phoneNumber:0});
        vm.sancionsshow=true;
    }
    vm.townhalls = angular.copy(townHalls);
    if (AclService.isAjuntament()) {
      var allowed = AclService.getAllowedAjuntamentIds();
      vm.townhalls = vm.townhalls.filter(function (t) {
        return allowed.indexOf(t.id) !== -1;
      });
    }
    vm.currentSeason.iniDate = moment(vm.currentSeason.iniDate).toDate();
    vm.currentSeason.endDate = moment(vm.currentSeason.endDate).toDate();

    //vm.iniDate = (angular.isUndefined($state.current.data.initDate)) ? vm.currentSeason.iniDate : $state.current.data.initDate;
    //vm.endDate = (angular.isUndefined($state.current.data.endDate)) ? vm.currentSeason.endDate : $state.current.data.endDate;
    var d = new Date();
    //d.setDate(d.getDate() - 7);
    vm.iniDate=d;
     var d2 = new Date();
    d2.setDate(d.getDate() + 7);
    vm.endDate=d2;
    
    vm.paginationLabel = {
      page: $filter('translate')('PAGE'),
      rowsPerPage: '',
      of: $filter('translate')('OF')
    };

    vm.matches = [];
    vm.selected = [];
    vm.select = undefined;

    vm.openMenu = function ($mdMenu, event) {
      $mdMenu.open(event);
    };

    if (vm.townhalls.length === 1) {
      vm.selectedTownHall = vm.townhalls[0];
      $state.current.data.townHall = vm.selectedTownHall;
    } else {
      vm.selectedTownHall = ($state.current.data.townHall) ? $state.current.data.townHall : undefined;
    }
    vm.currentPage = 1;
    vm.matchesPerPage = 1500;
    vm.queryOrder = 'championship';
    vm.sort = 'championship';

    vm.applyFilters = applyFilters;
    vm.reorder = reorder;
    vm.getNewPage = getNewPage;

    function applyFilters() {
      vm.isFiltered = true;
      query(vm.selectedTownHall.id, vm.iniDate, vm.endDate, vm.currentPage, vm.matchesPerPage, vm.sort);
    }

    function reorder(order) {
      vm.sort = order;
      query(vm.selectedTownHall.id, vm.iniDate, vm.endDate, vm.currentPage, vm.matchesPerPage, vm.sort);
    }

    function getNewPage(page, limit) {
      vm.currentPage = page;
      vm.matchesPerPage = limit;
      query(vm.selectedTownHall.id, vm.iniDate, vm.endDate, vm.currentPage, vm.matchesPerPage, vm.sort);
    }

    function query(townHallId, iniDate, endDate, page, size, sort) {
      var parameters = {
        townHall: townHallId,
        initDate: moment(iniDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
        page: page,
        size: size
      };
      //Optional parameters
      if (angular.isDefined(sort)) {
        parameters.sort = sort;
      }
      $scope.verpartido=function(ident,equip1,equip2){
         
          if((typeof equip1!=="undefined")&&(typeof equip2!=="undefined"))
          {
          var url = $state.href("home.resultats",{idPartit: ident});
                  window.open(url,'_blank');
     
          }
      };
      
      Comite.get(parameters, function (data) {
          _.remove(vm.matches);
          var isCC="";
          var isvT="";
          var resultat="";
          var isSus="";
          var isTJ="";
          var isObs="";
          
          angular.forEach(data.matches, function (match) {
            var localTeam = findItemById(data.teams, match.localTeamId);
            var visitorTeam = findItemById(data.teams, match.visitorTeamId);
            var facility = findItemById(data.facilities, match.facilityId);
            var championship = findItemById(data.championships, match.championshipId);
            if (match.isCC){
                isCC="C";
            }else{
                isCC="";
            }
            if(match.isVotat){
                isvT="";
            }else{
                isvT="N";
            }
            if (match.isSuspes){
                isSus="S";
            }
            else{
                isSus="";
            }
              if (match.isVotatTJ){
                isTJ="";
            }
            else{
                isTJ="N";
            }
             if (match.isObservacions){
               // isObs="S";
               isObs = match.observacions;
            }
            else{
                isObs="";
            }
            resultat=match.resultat;
            vm.matches.push({
              town: angular.isDefined(facility) ? facility.town : '-',
              matchDay: match.matchDay,
              localTeam: localTeam,
              visitorTeam: visitorTeam,
              date: moment(match.date).format('L'),
              time: match.time === null ? '--:--' : match.time,
              facility: facility,
              championship: championship,
              isCC:isCC,
              isVotatTecnic:isvT,
              idPartit:match.id,
              resultat:resultat,
              isSuspes:isSus,
              isVotatTJ:isTJ,
              isObservacions:isObs
             
            });
          });
          vm.maxMatches = data.page.count;
        },
        function (error) {
          var message = angular.isDefined(error.data.message) ? error.data.message : 'TOAST_ERROR';
          $mdToast.show(
            $mdToast.simple()
              .textContent($filter('translate')(message))
              .position('bottom left')
              .hideDelay(3000)
          );
        });
    }

    function findItemById(collection, itemId) {
      return _.find(collection, function (i) {
        return i.id === itemId;
      });
    }

    $scope.$watch('vm.iniDate', function (newDate) {
      $state.current.data.initDate = newDate;
    });

    $scope.$watch('vm.endDate', function (newDate) {
      $state.current.data.endDate = newDate;
    });

    $scope.$watch('vm.selectedTownHall', function (selectedTownHall) {
      $state.current.data.townHall = selectedTownHall;
    });
 $scope.exportToExcel= ((function() {
          var uri = 'data:application/vnd.ms-excel;base64,'
            , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
            , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
            , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
          return function(table, name) {
            table = document.getElementById(table);
            
            var ctx = {worksheet: name || 'Report', table: table.innerHTML};
            window.location.href = uri + base64(format(template, ctx));
          }
        })());
  $scope.sancions=((function(){
        var iniDate1=moment(vm.iniDate).format('YYYY-MM-DD');
        var endDate1= moment(vm.endDate).format('YYYY-MM-DD');
        var url = $state.href("home.sancions",{dataini: iniDate1,datafi:endDate1});
                  window.open(url,'_blank');
  })) ;     


  }
  
  
  
}());
